import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-26/task-01";

const task: Slide = {
  titleHtml:
    "Which of the following is true regarding the evaluation of sound quality for systems<br>with a known reference?",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
